module.exports = __webpack_public_path__ + "img/mn.410e95d9.svg";